import { useId } from 'react';
import { Info } from 'lucide-react';
import { cn } from '../../../../lib/utils';
import { InfoTipProps } from './interface';

/** Small info icon that reveals `text` on hover or keyboard focus. */
function InfoTip({ text, label = 'More info', className }: InfoTipProps) {
  const id = useId();
  return (
    <span className={cn('group relative inline-flex', className)}>
      <button
        type="button"
        aria-label={label}
        aria-describedby={id}
        className="rounded-full text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <Info className="h-3.5 w-3.5" />
      </button>
      <span
        id={id}
        role="tooltip"
        className="pointer-events-none absolute bottom-full left-1/2 z-10 mb-1 hidden w-56 -translate-x-1/2 rounded-md border bg-popover px-2 py-1.5 text-xs font-normal text-popover-foreground shadow-md group-hover:block group-focus-within:block"
      >
        {text}
      </span>
    </span>
  );
}

export { InfoTip };
export type { InfoTipProps };
